const businessRulesMappings: Record<string, string> = {
  ai_onboarding_a_b_testing_override_enabled: 'Ai Onboarding A B Test Override Enabled (SMBs)',
  ai_onboarding_enabled: 'AI Onboarding Enabled (SMBs)',
  allow_custom_location: 'Allow Custom Location',
  allow_night_shifts: 'Allow Night Shifts',
  allow_reports: 'Allow reports',
  forbid_punch: 'Forbid punching',
  home_page_enabled: 'Home Page Enabled (SMBs)',
  is_onboarding_enabled: 'Onboarding Enabled (SMBs)',
  is_payroll_export_overview_enabled: 'Old Payroll Export Enabled (Enterprises)',
  night_shift_end_time: 'Night Shift End Time',
  night_shift_start_time: 'Night Shift Start Time',
  payroll_auto_create_locks_enabled: 'Payroll Auto Create Locks Enabled (SMBs)',
  show_payroll_issues: 'Payroll Issues on Closure Enabled (SMBs)',
  simplify_payroll_closure_buttons_enabled: 'Simplified Payroll Closure Enabled (SMBs)',
  weekly_report_email_enabled: 'Weekly Email Enabled (SMBs)'
};

export default businessRulesMappings;
